import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CycleI } from '~src/interfaces/cycle.interface';
import { translateContent } from '~src/services/translationServices';
import TimeOutButton from '~src/shared/buttons/TimeOutButton';
import DaysLeft from '~src/shared/daysLeft/DaysLeft';

import PopoverInfo from './PopoverInfo';
import { timerCountDown } from './cards/RedirectCard';
import {
  HeaderContainer,
  Separator,
  InfoContainer,
  CycleTitle,
  CycleName,
  ButtonContainer,
} from './cards/redirectCard.sc';
import { TimeLeft } from './shared.sc';

interface Props {
  hideButton: boolean;
  redirectToQS: () => void;
  startProgress: boolean;
  progress: number;
  nextCycle: CycleI;
  redirectPack: string;
  nextMinutes: number;
}

const RedirectAction: FC<Props> = (props) => {
  const {t} = useTranslation();

  return (
    <ButtonContainer $hide={props.hideButton}>
      <HeaderContainer>
        <span>
          <span data-translation="x.questions.redirect.subheader.text">
            {t('x.questions.redirect.subheader.text')}
            <Separator>-</Separator>
          </span>
          <span hidden={!props.nextMinutes}>{t('x.questions.redirect.subheader.minutes', {count: props.nextMinutes})}</span>
        </span>
      </HeaderContainer>
      <InfoContainer>
        <TimeOutButton
          onClick={props.redirectToQS}
          start={props.startProgress}
          time={timerCountDown}
          finishedCall={props.redirectToQS}
          progress={props.progress}
        />
        <CycleTitle>
          <CycleName>{translateContent(props.nextCycle.survey.name)}</CycleName>
          <PopoverInfo
            selection={
              props.redirectPack === 'self_assessment' || props.redirectPack === 'assessment'
                ? null
                : props.redirectPack
            }
            isSelfAssessment={props.redirectPack === 'self_assessment'}
            isAnonymous={props.nextCycle.schedule.anonymous}
            t={t}
          />
          <TimeLeft>
            {props.nextCycle.dueDate &&
              <DaysLeft t={t} date={props.nextCycle.dueDate} withDot={false}/>}
          </TimeLeft>
        </CycleTitle>
      </InfoContainer>
    </ButtonContainer>
  );
};

export default RedirectAction;
